import React, { useState } from "react";
import { TextField, Autocomplete } from "@mui/material";
import { Controller, UseControllerProps } from "react-hook-form";
import axios from "axios";

interface ControlledTextFieldProps {
    name: string;
    defaultValue?: string;
    rules?: UseControllerProps['rules'];
    label: string;
    control: any;
}

const PincodeField: React.FC<ControlledTextFieldProps> = ({
    name,
    defaultValue = "",
    rules,
    label,
    control,
}) => {
    const [options, setOptions] = useState<string[]>([]);
    const [loading, setLoading] = useState(false);

    const fetchPincode = async (place: string) => {
        if (!place) return;
        try {
            setLoading(true);
            const response = await axios.get(
                `https://api.postalpincode.in/postoffice/${place}`
            );

            if (response.data && response.data[0]?.Status === "Success") {
                const pincodes = response.data[0].PostOffice.map(
                    (po: any) => `${po.Pincode} - ${po.Name}`
                );
                setOptions(pincodes);
            } else {
                setOptions(["Not found"]);
            }
        } catch (error) {
            console.error(error);
            setOptions(["Error"]);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            rules={rules}
            render={({ field, fieldState }) => (
                <Autocomplete
                    freeSolo
                    options={options}
                    loading={loading}
                    value={field.value || ""} // 👈 bind RHF value properly
                    onChange={(_, newValue) => {
                        if (newValue) {
                            // keep only the pincode part
                            const pin = newValue.split(" - ")[0];
                            field.onChange(pin);
                        } else {
                            field.onChange("");
                        }
                    }}
                    sx={{
                        '& .MuiInputBase-input': {
                            fontSize: '0.75rem', // Reduce the font size
                        },
                        '& .MuiFormHelperText-root': {
                            fontSize: '0.75rem', // Reduce the font size of the error message
                        },
                        '& .MuiInputLabel-root': {
                            fontSize: '0.75rem', // Reduce the font size of the label
                        },
                        '& .MuiDrawer-root': {
                            fontSize: '0.75rem',
                            color: 'red', // Change text color of listbox items

                        },
                    }}
                    onInputChange={(_, newInputValue, reason) => {
                        if (reason === "input") {
                            field.onChange(newInputValue); // 👈 update RHF value while typing
                            if (newInputValue.length > 2) {
                                fetchPincode(newInputValue);
                            }
                        }
                    }}
                     slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: 'preventOverflow',
                          options: {
                            boundary: 'window',
                          },
                        },
                      ],
                    },
                    paper: {
                      sx: {
                        '& .MuiAutocomplete-listbox': {

                        },
                        '& .MuiAutocomplete-option': {

                          fontSize: '0.75rem', // Adjust font size
                          '&:hover': {
                            backgroundColor: 'lightgray', // Optional: Change background on hover
                          },
                        },
                      },
                    },
                  }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={label}
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            size="small"
                            fullWidth
                            sx={{
                                '& .MuiInputBase-input': {
                                    fontSize: '0.75rem', // Reduce the font size
                                },
                                '& .MuiFormHelperText-root': {
                                    fontSize: '0.75rem', // Reduce the font size of the error message
                                },
                                '& .MuiInputLabel-root': {
                                    fontSize: '0.75rem', // Reduce the font size of the label

                                },

                            }}
                        />
                    )}
                />
            )}
        />
    );
};

export default PincodeField;
